var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-vartical",class:{'disable':!_vm.selected},on:{"click":_vm.onCkick}},[_c('div',{staticClass:"center"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.loadImg}})]),_vm._v(" "),_c('div',{staticClass:"text center"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4197433b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Molecules/ImageVertical.vue
// module id = null
// module chunks = 